import classNames from "classnames";
import * as React from "react";
import { Keys } from "~/common/enums";
import { icon } from "~/sharedComponents/icons";
import { imageAnnotationsResx } from "../../../resxDist/imageAnnotationsResx";
import { messageBoardResx } from "../../../resxDist/messageBoardResx";
import { ButtonContrast, ButtonFlag } from "../../../sharedComponents/buttons";
import { RestoreFocus } from "../../../sharedComponents/restoreFocus";
import { FocusTrap } from "../../../sharedHOC/adjustContainer/FocusTrap";
import { nextImage, previousImage, showMessages } from "../actions";
import { ImageAnnotationContainer } from "../containers/ImageAnnotationContainer";
import { Image } from "../types";
import * as styles from "./Dialog.less";

export interface DialogProps {
    isOpened: boolean;
    close: F<void>;
    image: Image;
    showMessages: typeof showMessages;
    previousImage: typeof previousImage;
    nextImage: typeof nextImage;
}

export class Dialog extends React.Component<DialogProps> {
    constructor(props: DialogProps) {
        super(props);

        this.showMessagesContainer = this.showMessagesContainer.bind(this);
    }
    showMessagesContainer() {
        this.props.showMessages();
    }

    escHandler = (event: React.KeyboardEvent) => {
        if (!event.isDefaultPrevented()) {
            switch (event.key) {
                case Keys.Escape: {
                    this.props.close();
                    break;
                }
                case Keys.ArrowLeft: {
                    this.props.previousImage();
                    break;
                }
                case Keys.ArrowRight: {
                    this.props.nextImage();
                    break;
                }
            }
        }
    };

    getTitleName = (name: string, version?: number, isShowVersion?: boolean) => {
        const versionMsg = isShowVersion ? `(${messageBoardResx.FileVersionShort}${version})` : "";
        return `${name} ${versionMsg}`;
    };

    render() {
        const {
            isOpened,
            close,
            image: { source, filename, title, version, isShowVersion },
        } = this.props;
        const titleMsg = this.getTitleName(title, version, isShowVersion);
        const titleAttr = this.getTitleName(filename, version, isShowVersion);

        return (
            <>
                {isOpened && (
                    <RestoreFocus>
                        <FocusTrap autoFocus={true} enforceFocus={true} handleFocusedElementUnmounting={true}>
                            <div
                                role={"dialog"}
                                aria-modal={true}
                                aria-label={titleMsg}
                                onKeyDown={this.escHandler}
                                className={classNames([styles.dialog, "ko-inline-popup", "ep-dark-theme"])}
                            >
                                <div className={styles.header}>
                                    <ButtonContrast
                                        iconName={icon.chevron_left}
                                        action={close}
                                        text={imageAnnotationsResx.back}
                                        flags={ButtonFlag.Small}
                                    />
                                    <div className={styles.title} title={titleAttr}>
                                        {titleMsg}
                                    </div>
                                    <ButtonContrast
                                        iconName={icon.comment}
                                        action={this.showMessagesContainer}
                                        text={imageAnnotationsResx.comments}
                                        flags={ButtonFlag.Small}
                                    />
                                </div>
                                <ImageAnnotationContainer />
                                <div className={styles.footer}>
                                    <a href={source} download={true} className={styles.download}>
                                        {imageAnnotationsResx.download}
                                    </a>
                                </div>
                            </div>
                        </FocusTrap>
                    </RestoreFocus>
                )}
            </>
        );
    }
}
